import { Box, Button, HStack, Text, Tooltip, VStack } from "@chakra-ui/react"
import { Global } from "container/global"
import { useVestingRewardByAddress } from "container/reward/Vesting"
import { User } from "container/user"
import { XState } from "container/xstate"
import { useNotification } from "hook/useNotification"
import React from "react"

import { MotionVStack } from "../"
import { PoolInfo } from "../PoolInfo"

export function Claim() {
    const { state: current } = XState.useContainer()

    const {
        state: { address },
    } = User.useContainer()

    const { isRedeemable, totalRedeemableAmount, totalLockedAmount } = useVestingRewardByAddress(address)

    const {
        actions: { toggleClaimModal },
    } = Global.useContainer()

    const { notifyInfo } = useNotification()

    return (
        <MotionVStack
            overflow="hidden"
            animate={{
                height: current.matches("home") ? 313 : 4,
                opacity: current.matches("home") ? 1 : 0.1,
            }}
            w="100%"
            mb="-8px"
            px={5}
            spacing={4}
            pt={current.matches("home") ? 5 : 0}
            bgGradient="linear(180deg, #323232 0%, #232323 100%);"
        >
            <HStack w="100%" spacing={0}>
                <VStack
                    flexGrow={1}
                    py="16px"
                    spacing={0}
                    transition="all 0.21s"
                    position="relative"
                    top="0px"
                    borderRadius="20px"
                    _hover={{ top: "-2px", bg: "rgba(255,255,255,0.05)" }}
                    _active={{
                        top: "4px",
                    }}
                    as="button"
                    disabled={!isRedeemable}
                    onClick={toggleClaimModal}
                >
                    <Text w="90%" color="#24DA97" fontWeight="bold" fontSize="11px">
                        PERP REWARD
                    </Text>
                    <Text w="90%" isTruncated color="#FFFFFF" fontWeight="bold" fontSize="19px">
                        {totalRedeemableAmount ? totalRedeemableAmount.toString() : "0.00"}
                    </Text>
                    <Tooltip hasArrow placement="top" label="Amount vesting until later dates.">
                        <Text w="90%" opacity={0.6} isTruncated color="#FFFFFF" fontWeight="bold" fontSize="11px">
                            {totalLockedAmount ? totalLockedAmount.toString() : "--"} Vesting
                        </Text>
                    </Tooltip>
                    <Box pt="12px">
                        <Button size="xs" colorScheme="gray" disabled={!isRedeemable}>
                            CLAIM
                        </Button>
                    </Box>
                </VStack>
                <VStack
                    flexGrow={1}
                    py="16px"
                    mt={5}
                    as="button"
                    spacing={0}
                    transition="all 0.21s"
                    position="relative"
                    top="0px"
                    borderRadius="20px"
                    _hover={{ top: "-2px", bg: "rgba(255,255,255,0.05)" }}
                    _active={{
                        top: "4px",
                    }}
                    onClick={() => {
                        notifyInfo({
                            title: "USDC Reward coming soon",
                        })
                    }}
                >
                    <Text w="90%" color="#3C8CEA" fontWeight="bold" fontSize="11px">
                        USDC REWARD
                    </Text>
                    <Text w="90%" isTruncated color="#FFFFFF" fontWeight="bold" fontSize="19px">
                        0.00
                    </Text>

                    <Box pt="28px">
                        <Button isDisabled size="xs" colorScheme="gray">
                            CLAIM
                        </Button>
                    </Box>
                </VStack>
            </HStack>

            <PoolInfo />
        </MotionVStack>
    )
}
